import './Fixture.css';
import React from 'react';

import Metas from '@views/Metas';
import FixtureView from '@views/Fixture';

export const FixtureEmbed = () => (
  <div className="Fixture Fixture-embed">
    <Metas
      title={`Fixture Mundial 2026`}
      description="El juego de Página|12 para predecir los resultados del Mundial de Fútbol 2026"
    />
    <FixtureView />
  </div>
);

FixtureEmbed.displayName = 'FixtureEmbed';
FixtureEmbed.propTypes = {};
FixtureEmbed.defaultProps = {};

export default FixtureEmbed;
